<template>
  <div id="realTimeMap">
    <v-container fluid class="overrideContainer">
      <v-row>
        <v-col md="9" cols="12" lg="9" class="overrideCol">
          <div class="mapWrapper">
            <template v-if="mapType !== null">
                <GoogleRouteOptimizationComponent v-if="mapType == 1" />
                <LeafletRouteOptimizationComponent v-if="mapType == 0"/>

                 <v-card class="mt-3 ml-6">
          <label class="text-caption ml-3" v-if="mrpReport">
            {{ mrpReport[0].nazivTabele }} - <span v-html="mrpReport[0].opis"></span>
          </label>
         <v-simple-table v-if="mrpReport" dense>
            <template v-slot:default>
              <thead>
                <tr >
                  <th style="" v-for="(header, index) in mrpReport[0].table.tableHeader" :key="'table' + index">
                    {{ $t(`optimization.headers.${header}`) }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, index) in mrpReport[0].table.tableBody"
                  :key="'body' + index"
                >
                  <td :style="'background-color:' + column.style" :key="'column'+index" v-for="(column, index) in row.stavke">
                    {{ column.value === null || column.value === 'NaN' ? 0 : column.value }}
                  </td>
                </tr>
              </tbody>
            </template>
        </v-simple-table>
       <v-row v-if="mrpReport" class="pl-4 pt-3 pb-2">
         <v-btn color="success" small @click="exportAsExcel" class="ml-2 mr-2 font-weight-light">Excel</v-btn>
         <v-btn color="success" small @click="exportAsPdf" class="mr-2 font-weight-light">PDF</v-btn>
       </v-row>
       </v-card>
            </template>
            
            <div v-else>
              Initializing map...
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="3" lg="3">
           <v-row no-gutters class="pl-4 pt-3 pr-4">
               <v-col cols="12">
                 <v-autocomplete outlined dense hide-details :items="savedRoutes" v-model="selectedOptimization" :label="$t('optimization.saved')" item-text="name" item-value="id"/>
                 <v-text-field :error-messages="nameError" outlined dense v-model="name" :label="$t('optimization.name')"></v-text-field>
               </v-col>
               <v-col cols="12">
                 <v-autocomplete multiple outlined dense hide-details :items="drivers" v-model="selectedDrivers" :label="$t('drivers')" item-text="name" item-value="id" />
               </v-col>
               <v-col cols="12" class="">
                  <v-checkbox
                    dense
                    color="primary"
                    v-model="startPointAndEndPointAreSame"
                    :label="$t('optimization.startPointAndEndPointAreSame')"
                  ></v-checkbox>
               </v-col>
               <v-col cols="12" class="mb-3">
                  <v-row no-gutters>
                      <v-col cols="12">
                         <v-btn small class="mb-1" :color="sourceSelecting ? 'primary' : 'default'" @click="beginSourceSelection">{{ $t("optimization.startPoint") }}</v-btn> <br>
                      </v-col>
                      <v-col cols="12">
                        <v-row no-gutters v-if="sourceSelecting">
                            <v-col cols="6" class="pr-1"><v-autocomplete hide-details :items="posses" @change="choosePosSource" item-text="name" item-value="id" :label="$t('optimization.choosePoi')" outlined dense></v-autocomplete></v-col>
                            <v-col cols="6" class="pt-3 pl-3"><label class="text-caption">{{ $t('optimization.mapClick') }}</label></v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row no-gutters>
                          <v-col cols="6" class="pr-1">
                            <v-text-field outlined :disabled="!sourceSelecting" hide-details dense type="number" @input="updateSource" v-model="sourceLat" :label="$t('lat')"/>
                          </v-col>
                           <v-col cols="6">
                            <v-text-field outlined :disabled="!sourceSelecting" hide-details type="number" dense @input="updateSource" v-model="sourceLng" :label="$t('lng')"/>
                          </v-col>
                        </v-row>
                       
                    </v-col>
                      <v-col cols="12">
                        <label v-if="markers && markers.length" class="text-caption"> {{ $t("startAddress") }}: {{ markers[0].address || markers[0].desc.split(';')[0] }} </label>
                      </v-col>
                  </v-row>
               </v-col>
               <v-col cols="12">
                  <v-row no-gutters>
                       <v-btn small :color="destinationSelecting ? 'primary' : 'default'"  @click="beginDestinationSelection">{{ $t("optimization.pickDestination") }}</v-btn>
                       <v-col cols="12">
                        <v-row no-gutters v-if="destinationSelecting">
                            <v-col cols="6"><v-autocomplete :items="filteredPosses" @change="choosePosDestination" item-text="name" item-value="id" :label="$t('optimization.choosePoi')" outlined dense></v-autocomplete></v-col>
                            <v-col cols="6" class="pt-3 pl-3"><label class="text-caption">{{ $t('optimization.mapClick') }}</label></v-col>
                        </v-row>
                       </v-col>
                       <v-col cols="12">
                         <v-btn small color="primary" @click="clearZoom" v-if="routeSelected">{{ $t("optimization.showAll") }}</v-btn>
                       </v-col>
                        <v-col cols="12" v-for="(destination, index) in destinations" :key="'lantlngs-' + index">
                          <v-row no-gutters>
                            <v-col cols="1">
                              <v-icon :disabled="!destinationSelecting" color="primary" style="margin-top:20px;cursor:pointer" @click="zoomToPoint(destinationPoints[index] ? destinationPoints[index].route : destination, index)" small>mdi-magnify</v-icon>
                           </v-col>
                            <v-col cols="5" class="pr-1">
                              <v-text-field outlined readonly :disabled="!destinationSelecting" hide-details dense :persistent-hint="true" type="number" :value="destination.latlng.lat" :label="destination.name || $t('lat')"/>
                            </v-col>
                            <v-col cols="4">
                              <v-text-field outlined readonly :disabled="!destinationSelecting" hide-details type="number" dense :persistent-hint="true" :value="destination.latlng.lng" :label="destination.name || $t('lng')"/>
                            </v-col>
                          <v-col cols="1">
                              <v-icon :disabled="!destinationSelecting" small color="red" style="margin-top:20px;cursor:pointer" @click="removeDestination(destination)" class="ml-3">mdi-close-circle-outline</v-icon>
                          </v-col>
                          <template v-if="destinationPoints[index]" >
                             <label :style="'background-color:' + destinationPoints[index].color + ';height:17px'" class="ml-9 mt-1" >&nbsp;&nbsp;&nbsp;</label> <label class="ml-1 text-caption mt-1" > {{ destinationPoints[index].place }} ({{ destinationPoints[index].distance }}) ({{ destinationPoints[index].estimatedDuration }})</label>
                          </template>
                          </v-row>
                        </v-col>
                  </v-row>
               </v-col>
               <v-col cols="12" class="mt-5" v-if="!startPointAndEndPointAreSame">
                  <v-row no-gutters>
                      <v-col cols="12">
                         <v-btn small class="mb-1" :color="endPointSelecting ? 'primary' : 'default'" @click="beginEndPointSelection">{{ $t("optimization.endPoint") }}</v-btn> <br>
                      </v-col>
                      <v-col cols="12">
                        <v-row no-gutters v-if="endPointSelecting">
                            <v-col cols="6" class="pr-1"><v-autocomplete hide-details :items="posses" @change="choosePosEndPoint" item-text="name" item-value="id" :label="$t('optimization.choosePoi')" outlined dense></v-autocomplete></v-col>
                            <v-col cols="6" class="pt-3 pl-3"><label class="text-caption">{{ $t('optimization.mapClick') }}</label></v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row no-gutters>
                          <v-col cols="6" class="pr-1">
                            <v-text-field outlined :disabled="!endPointSelecting" hide-details dense type="number" @input="updateEndPoint" v-model="endPointLat" :label="$t('lat')"/>
                          </v-col>
                           <v-col cols="6">
                            <v-text-field outlined :disabled="!endPointSelecting" hide-details type="number" dense @input="updateEndPoint" v-model="endPointLng" :label="$t('lng')"/>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <template v-if="destinationPoints && destinationPoints.length > 0 && !startPointAndEndPointAreSame && endPoint">
                            <label :style="'background-color:' + destinationPoints[destinationPoints.length - 1].color + ';height:17px'" class="ml-9 mt-1"> 
                            &nbsp;&nbsp;&nbsp; 
                            </label>
                            <br/>
                            <label class="ml-1 text-caption mt-1" > {{ $t("endAddress") }}: {{ destinationPoints[destinationPoints.length - 1].place }}</label>
                        </template>
                      </v-col>
                  </v-row>
               </v-col>
               <v-col cols="12" class="mt-4">
                   <v-btn v-if="findRouteCondition" :disabled="loading" :loading="loading" color="success" small @click="findOptimizedRoutes">{{ $t('optimization.find') }}</v-btn>
                   <v-btn class="ml-2" v-if="findRouteCondition" :disabled="loading" color="warning" small @click="reset">{{ $t('optimization.reset') }}</v-btn>
                   <v-btn class="ml-2" v-if="destinationPoints && destinationPoints.length && findRouteCondition" :disabled="loading || saving" :loading="saving" color="success" small @click="saveOptimization">{{ $t('save') }}</v-btn>
                   <v-btn class="ml-2" v-if="destinationPoints && destinationPoints.length && selectedOptimization && findRouteCondition" :disabled="loading" color="warning" small @click="deleteOptimization">{{ $t('del') }}</v-btn>
                   <v-card
                    class="mx-auto"
                    max-width="500"
                  >
                  </v-card>
               </v-col>
               <v-col cols="12" class="mt-2">
                 <input ref="excelFileInput" type="file" accept=".xlsx,.xls" style="display:none" @change="onOptimizeFromExcelFileSelected" />
                 <v-btn small color="primary" :disabled="loading" @click="optimizeFromExcelDialogVisible = true">{{ $t('optimization.optimizeFromExcel.buttonLabel') }}</v-btn>
               </v-col>
               <v-col cols="12" v-if="serverError">
                 <label style="color:red" class="text-caption"> {{ $t("optimization.serverError") }} </label>
               </v-col>
           </v-row>

           <v-dialog v-model="optimizeFromExcelDialogVisible" persistent :retain-focus="false" max-width="650" @keydown.esc="closeOptimizeFromExcelDialog">
             <v-card flat tile>
               <v-toolbar color="primary" dark>
                 <v-toolbar-title>
                   <h5 class="white--text font-weight-light">{{ $t('optimization.optimizeFromExcel.buttonLabel') }}</h5>
                 </v-toolbar-title>
                 <v-spacer />
                 <base-icon-close @close="closeOptimizeFromExcelDialog" :x_small="true" />
               </v-toolbar>
               <v-card-text>
                 <route-optimization-excel-detail />
               </v-card-text>
               <v-col v-if="!optimizeFromExcelErrors.length">
                 <v-card-actions>
                   <v-row no-gutters dense>
                     <v-col v-if="optimizeFromExcelLoading">
                       <v-progress-circular :width="3" color="primary" indeterminate class="ml-8" />
                     </v-col>
                     <v-col v-else>
                       <v-row justify="end">
                         <v-btn small color="success" class="white--text font-weight-light mr-5" @click="$refs.excelFileInput.click()">{{ $t('optimization.optimizeFromExcel.buttonLabel') }}</v-btn>
                       </v-row>
                     </v-col>
                   </v-row>
                 </v-card-actions>
               </v-col>
               <v-col v-if="optimizeFromExcelErrors.length">
                 <v-card-actions>
                   <v-row no-gutters dense>
                     <v-col>
                       <v-list dense>
                         <v-list-item v-for="(err, i) in optimizeFromExcelErrors" :key="i">
                           <p class="error--text text-caption mb-0">{{ err }}</p>
                         </v-list-item>
                       </v-list>
                     </v-col>
                     <v-col>
                       <v-row justify="end">
                         <v-btn small color="secondary" class="white--text font-weight-light mr-3" @click="closeOptimizeFromExcelDialog">{{ $t('optimization.optimizeFromExcel.cancel') }}</v-btn>
                         <v-btn small color="primary" class="white--text font-weight-light mr-5" @click="$refs.excelFileInput.click()">{{ $t('optimization.optimizeFromExcel.retry') }}</v-btn>
                       </v-row>
                     </v-col>
                   </v-row>
                 </v-card-actions>
               </v-col>
             </v-card>
           </v-dialog>

            
            
        </v-col>
      </v-row>
      
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import store from '@/store/store'
import mapMixin from '../mapMixin.js'
import httpClient from '@/api/httpClient'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import DejaVuSansBase64 from '@/assets/fonts/DejaVuSans/DejaVuSansBase64'
import DejaVuSansBoldBase64 from '@/assets/fonts/DejaVuSans/DejaVuSansBoldBase64'
const Excel = require('exceljs')
export default {
  name: 'BaseRouteOptimizationComponent',
  data() {
    return {
      isDeleteMode: false,
      loading: false,
      savedRoutes: [],
      selectedOptimization: undefined,
      drivers: [],
      selectedDrivers: [],
      sourceLat: undefined,
      sourceLng: undefined,
      name: undefined,
      saving: false,
      nameError: [],
      posses: [],
      choosenPosses: [],
      serverError: false,
      startPointAndEndPointAreSame: true,
      endPointLat: undefined,
      endPointLng: undefined,
      totalDistance: 0,
      optimizeFromExcelLoading: false,
      optimizeFromExcelErrors: [],
      optimizeFromExcelDialogVisible: false
    }
  },
  mixins: [mapMixin],
  components: {
    LeafletRouteOptimizationComponent: () =>
      import('./LeafletRouteOptimization'),
    GoogleRouteOptimizationComponent: () => import('./GoogleRouteOptimization'),
    RouteOptimizationExcelDetail: () => import('@/components/bulk/RouteOptimizationExcelDetail'),
    BaseIconClose: () => import('@/components/BaseIconClose')
  },
  mounted() {
    this.loadDestinations()
    this.loadDrivers()
    httpClient.get('/pois?poiType=2').then(response => {
      this.posses = response.data
    })
  },
  beforeDestroy() {
    this.clearSelection()
  },
  computed: {
    ...mapState('optimization', [
      'sourceSelecting',
      'destinationSelecting',
      'source',
      'destinations',
      'markers',
      'routes',
      'mrpReport',
      'selectedRoute',
      'endPointSelecting',
      'endPoint'
    ]),
    routeSelected() {
      return this.selectedRoute != null
    },
    filteredPosses() {
      return this.posses.filter(
        x => !this.choosenPosses.some(y => y.id == x.id)
      )
    },
    destinationPoints() {
      let destinations = []
      for (let i = 1; i < this.markers.length; i++) {
        if (!this.routes[i - 1]) continue

        const descParts = this.markers[i].desc.split('=')
        const meters = descParts.length > 1
          ? parseFloat(descParts[1].split('m.;')[0].trim().replace(',', ''))
          : NaN

        const distance = isNaN(meters)
          ? ''
          : (meters / 1000).toFixed(2) + ' km'

        destinations.push({
          place: this.markers[i].address || this.markers[i].desc.split(';')[0],
          color: this.routes[i - 1].color,
          distance: distance,
          estimatedDuration: this.markers[i].estimatedDuration,
          route: this.routes[i - 1]
        })
      }
      return destinations
    },
    findRouteCondition() {
      if(this.startPointAndEndPointAreSame){
        return this.source && this.destinations.length
      }
      else{
        return this.source && this.destinations.length && this.endPoint
      }
    }
  },
  methods: {
    clearZoom() {
      store.dispatch('optimization/clearSelection')
    },
    reset() {
      store.dispatch('optimization/reset')
    },
    choosePosDestination(id) {
      if (!id) return
      const pos = this.posses.find(x => x.id == id)
      if (!pos) return
      this.choosenPosses.push(pos)
      store.dispatch('optimization/addDestination', {
        latlng: {
          lat: pos.coordinates[0].latitude,
          lng: pos.coordinates[0].longitude
        },
        id: pos.id,
        name: pos.name
      })
      store.dispatch(
        'optimization/setSelectedRoute',
        this.destinations.map(x => [x.latlng.lat, x.latlng.lng])
      )
    },
    choosePosSource(id) {
      if (!id) {
        store.dispatch('optimization/setSource', {
          latlng: { lat: undefined, lng: undefined }
        })
        return
      }
      const pos = this.posses.find(x => x.id == id)
      if (!pos) return
      store.dispatch('optimization/setSource', {
        latlng: {
          lat: pos.coordinates[0].latitude,
          lng: pos.coordinates[0].longitude
        }
      })
    },
    deleteOptimization() {
      httpClient
        .delete('routeoptimization/' + this.selectedOptimization)
        .then(() => {
          this.clearSelection()
          this.selectedOptimization = undefined
          this.loadDestinations()
        })
    },
    loadDestinations() {
      httpClient.get('/routeoptimization?type=1').then(result => {
        result.data.unshift({
          name: 'Izaberite...',
          id: null
        })
        this.savedRoutes = result.data
      })
    },
    loadDrivers() {
      httpClient.get('/drivers').then(result => {
        result.data.unshift({
          name: 'Izaberite...',
          id: null
        })
        this.drivers = result.data
      })
    },
    clearSelection() {
      store.dispatch('optimization/clearDestinations')
      store.dispatch('optimization/setRoutes', { routes: [], markers: [] })
      store.dispatch('optimization/setSource', undefined)
      store.dispatch('optimization/setEndPoint', undefined)
      this.choosenPosses = []
    },
    saveOptimization() {
      this.nameError = []
      this.saving = true
      const itemToSave = {
        name: this.name,
        driverIds: this.selectedDrivers,
        type: 1,
        routeData: JSON.stringify({
          routes: this.routes,
          markers: this.markers,
          mrpReport: this.mrpReport,
          existEndPoint: !this.startPointAndEndPointAreSame,
          totalDistance: this.mrpReport[0].table.tableBody[this.mrpReport[0].table.tableBody.length - 1].stavke.at(-2).value.slice(0, -4).replace(/,/g, '')
        })
      }

      if (this.selectedOptimization) {
        httpClient
          .put('/routeoptimization/' + this.selectedOptimization, itemToSave)
          .then(() => {
            this.loadDestinations()
            this.saving = false
          })
          .catch(error => {
            if (error.response.status == 422) {
              this.nameError = ['Naziv je već u upotrebi.']
            }
            this.saving = false
          })
      } else {
        if (!this.name) {
          this.nameError = ['Naziv optimizacije je obavezan.']
          this.saving = false
          return
        }

        httpClient
          .post('/routeoptimization', itemToSave)
          .then(() => {
            this.loadDestinations()
            this.saving = false
          })
          .catch(error => {
            if (error.response.status == 422) {
              this.nameError = ['Naziv je već u upotrebi.']
            }
            this.saving = false
          })
      }
    },
    zoomToPoint(latlng, index) {
      store.dispatch('optimization/setSelectedRoute', {
        route: latlng.coordinates ? latlng.coordinates : [latlng.latlng],
        index
      })
    },
    removeDestination(marker) {
      if (marker.id) {
        this.choosenPosses = this.choosenPosses.filter(x => x.id != marker.id)
      }

      var routeIndex = this.destinations.indexOf(marker)
      this.destinations.splice(routeIndex, 1)
      store.dispatch('optimization/removeRoute', routeIndex)
    },
    updateSource() {
      store.dispatch('optimization/setSource', {
        latlng: {
          lat: this.sourceLat,
          lng: this.sourceLng
        }
      })
    },
    beginSourceSelection() {
      store.dispatch('optimization/setSourceSelecting', true)
    },
    beginDestinationSelection() {
      store.dispatch('optimization/setDestinationSelecting', true)
    },
    findOptimizedRoutes() {
      this.loading = true
      this.serverError = false

      var requestObject = {
        source: {
          latitude: this.source.latlng.lat,
          longitude: this.source.latlng.lng
        },
        destinations: [],
        isCircular: this.startPointAndEndPointAreSame
      }

      for (const d of this.destinations) {
        requestObject.destinations.push({
          latitude: d.latlng.lat,
          longitude: d.latlng.lng
        })
      }

      if(this.startPointAndEndPointAreSame){
        requestObject.destinations.push({
          latitude: this.source.latlng.lat,
          longitude: this.source.latlng.lng
        })
      }
      else{
        requestObject.destinations.push({
          latitude: this.endPoint.latlng.lat,
          longitude: this.endPoint.latlng.lng
        })
      }

      httpClient
        .post('routeoptimizer/optimize', requestObject)
        .then(response => {
          if (!response.data.routes.length) {
            this.loading = false
            this.serverError = true
          }

          response.data.routes.forEach(x => {
            x.visible = true
          })

          // response.data.mrpReport[0].table.tableHeader.unshift('Path')

          store.dispatch('optimization/setRoutes', response.data)

          const optimizedMarkers = response.data.markers.slice(1)
          const markersToMatch = this.startPointAndEndPointAreSame
            ? optimizedMarkers.slice(0, -1)
            : optimizedMarkers

          const reorderedDestinations = []
          for (const marker of markersToMatch) {
            const match = this.destinations.find(d =>
              Math.abs(d.latlng.lat - marker.latitude) < 0.001 &&
              Math.abs(d.latlng.lng - marker.longitude) < 0.001
            )
            if (match) reorderedDestinations.push(match)
          }

          if (reorderedDestinations.length === this.destinations.length) {
            store.dispatch('optimization/setDestinations', reorderedDestinations)
          }

          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.serverError = true
        })
    },
    beginEndPointSelection(){
      store.dispatch('optimization/setEndPointSelecting', true)
    },
    choosePosEndPoint(id) {
      if (!id) {
        store.dispatch('optimization/setEndPoint', {
          latlng: { lat: undefined, lng: undefined }
        })
        return
      }
      const pos = this.posses.find(x => x.id == id)
      if (!pos) return
      store.dispatch('optimization/setEndPoint', {
        latlng: {
          lat: pos.coordinates[0].latitude,
          lng: pos.coordinates[0].longitude
        }
      })
    },
    updateEndPoint() {
      store.dispatch('optimization/setEndPoint', {
        latlng: {
          lat: this.endPointLat,
          lng: this.endPointLng
        }
      })
    },
    closeOptimizeFromExcelDialog() {
      this.$refs.excelFileInput.value = ''
      this.optimizeFromExcelErrors = []
      this.optimizeFromExcelDialogVisible = false
    },
    onOptimizeFromExcelFileSelected(event) {
      const file = event.target.files[0]
      this.$refs.excelFileInput.value = ''
      if (!file) return
      this.importFromExcel(file)
    },
    importFromExcel(file) {
      this.optimizeFromExcelLoading = true
      this.optimizeFromExcelErrors = []
      this.serverError = false

      const formData = new FormData()
      formData.append('formFile', file)

      httpClient
        .post('routeoptimizer/optimizefromexcel', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(response => {
          response.data.routes.forEach(x => {
            x.visible = true
          })
          // response.data.mrpReport[0].table.tableHeader.unshift('Path')
          store.dispatch('optimization/setRoutes', response.data)
          store.dispatch('optimization/clearDestinations')
          const markers = response.data.markers
          store.dispatch('optimization/setSource', {
            latlng: { lat: markers[0].latitude, lng: markers[0].longitude }
          })
          for (let i = 1; i < markers.length - 1; i++) {
            store.dispatch('optimization/addDestination', {
              latlng: { lat: markers[i].latitude, lng: markers[i].longitude }
            })
          }
          const lastMarker = markers[markers.length - 1]
          const isCircular =
            Math.abs(lastMarker.latitude - markers[0].latitude) < 0.0001 &&
            Math.abs(lastMarker.longitude - markers[0].longitude) < 0.0001
          if (isCircular) {
            this.startPointAndEndPointAreSame = true
            store.dispatch('optimization/setEndPoint', undefined)
          } else {
            this.startPointAndEndPointAreSame = false
            store.dispatch('optimization/setEndPoint', {
              latlng: { lat: lastMarker.latitude, lng: lastMarker.longitude }
            })
          }
          this.optimizeFromExcelLoading = false
          this.optimizeFromExcelDialogVisible = false
        })
        .catch(error => {
          this.optimizeFromExcelLoading = false
          const status = error.response && error.response.status
          if (status === 400) {
            this.optimizeFromExcelErrors = [this.$t('optimization.optimizeFromExcel.errors.invalidFormat')]
          } else if (status === 422) {
            const data = error.response.data
            this.optimizeFromExcelErrors = data.errors.map(e => e.Error)
          } else if (status === 502) {
            this.optimizeFromExcelErrors = [this.$t('optimization.optimizeFromExcel.errors.serviceUnavailable')]
          } else {
            this.optimizeFromExcelDialogVisible = false
            this.serverError = true
          }
        })
    },
    exportAsExcel() {
      const workbook = new Excel.Workbook()
      workbook.creator = 'Puregreen'
      const ws = workbook.addWorksheet('Route Optimization')
      const headers = this.mrpReport[0].table.tableHeader.map(h => ({
        name: this.$t(`optimization.headers.${h}`),
        filterButton: false
      }))
      const data = this.mrpReport[0].table.tableBody.map(row =>
        row.stavke.map(col => (col.value === null || col.value === 'NaN' ? 0 : col.value))
      )
      ws.addTable({
        name: 'OptimizationTable',
        ref: 'A1',
        headerRow: true,
        totalsRow: false,
        style: { theme: 'TableStyleLight20', showRowStripes: true },
        columns: headers,
        rows: data
      })
      ws.columns.forEach(column => {
        let dataMax = 0
        column.eachCell({ includeEmpty: true }, cell => {
          const len = cell.value ? cell.value.toString().length : 0
          if (len > dataMax) dataMax = len
        })
        column.width = dataMax < 10 ? 10 : dataMax + 5
      })
      workbook.xlsx.writeBuffer().then(buffer => {
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = `${this.name || 'RouteOptimization'}.xlsx`
        anchor.click()
        window.URL.revokeObjectURL(url)
      })
    },
    exportAsPdf() {
      const headers = this.mrpReport[0].table.tableHeader.map(h => ({
        content: this.$t(`optimization.headers.${h}`),
        styles: { minCellWidth: 15, fontSize: 6 }
      }))
      const rows = this.mrpReport[0].table.tableBody.map(row =>
        row.stavke.map(col => ({
          content: col.value === null || col.value === 'NaN' ? 0 : col.value,
          styles: { minCellWidth: 15, fontSize: 6 }
        }))
      )
      const doc = new jsPDF('landscape')

      doc.addFileToVFS('DejaVuSans.ttf', DejaVuSansBase64)
      doc.addFont('DejaVuSans.ttf', 'DejaVuSans', 'normal')
      doc.addFileToVFS('DejaVuSans-Bold.ttf', DejaVuSansBoldBase64)
      doc.addFont('DejaVuSans-Bold.ttf', 'DejaVuSans', 'bold')
      doc.setFont('DejaVuSans', 'normal')

      doc.autoTable({
        head: [headers],
        body: rows,
        startY: 10,
        styles: { font: 'DejaVuSans', fontStyle: 'normal', fontSize: 6 },
        headStyles: { font: 'DejaVuSans', fontStyle: 'bold', fontSize: 6 }
      })
      doc.save(`${this.name || 'RouteOptimization'}.pdf`)
    }
  },
  watch: {
    isDeleteMode: {
      handler() {
        store.dispatch('optimization/setIsDeleteMode', this.isDeleteMode)
      }
    },
    source: {
      handler() {
        if (!this.source) {
          this.sourceLat = ''
          this.sourceLng = ''
          return
        }
        this.sourceLat = this.source.latlng.lat
        this.sourceLng = this.source.latlng.lng
      }
    },
    selectedOptimization: {
      handler() {
        if (!this.selectedOptimization) {
          this.clearSelection()
          return
        }

        const optimization = this.savedRoutes.filter(
          x => x.id == this.selectedOptimization
        )[0]

        this.name = optimization.name
        this.selectedDrivers = optimization.driverIds
        const routeData = JSON.parse(optimization.routeData)
        store.dispatch('optimization/setRoutes', routeData)
        store.dispatch('optimization/setSource', {
          latlng: {
            lat: routeData.markers[0].latitude,
            lng: routeData.markers[0].longitude
          }
        })

        let existEndPoint = routeData.existEndPoint
        if(existEndPoint) {
          store.dispatch('optimization/setEndPoint', {
            latlng: {
              lat: routeData.markers[routeData.markers.length - 1].latitude,
              lng: routeData.markers[routeData.markers.length - 1].longitude
            }
          })
        }

        this.startPointAndEndPointAreSame = !existEndPoint

        let avaliibleDestinations = !existEndPoint ? routeData.markers.length : routeData.markers.length - 1

        store.dispatch('optimization/clearDestinations')
        for (let i = 1; i < avaliibleDestinations; i++) {
          store.dispatch('optimization/addDestination', {
            latlng: {
              lat: routeData.markers[i].latitude,
              lng: routeData.markers[i].longitude
            }
          })
        }

      }
    },
    endPoint: {
      handler() {
        if (!this.endPoint) {
          this.endPointLat = ''
          this.endPointLng = ''
          return
        }
        this.endPointLat = this.endPoint.latlng.lat
        this.endPointLng = this.endPoint.latlng.lng
      }
    }
  }
}
</script>

<style scoped>
.overrideContainer {
  padding: 0px !important;
}

.overrideCol {
  padding: 0px !important;
}
</style>
